module.exports = __webpack_public_path__ + "img/9791156020769.ade5d464.jpg";